export default __webpack_public_path__ + "static/media/fob.c82f9b60.png";